import classNames from 'classnames';

export const getActiveState = (active: boolean, reverseOperation?: boolean) => (reverseOperation ? !active : active);

export const getToggleContainerClass = ({
  loading,
  activeState,
  className,
  disabled,
}: {
  loading: boolean;
  activeState: boolean;
  className?: string;
  disabled?: boolean;
}) =>
  classNames(
    'transition duration-500 rounded-full appearance-none cursor-pointer flex items-center shrink-0 w-9 h-5 p-0.5',
    {
      'cursor-not-allowed pointer-events-none': loading || disabled,
      'fill-dark': activeState && !disabled,
      'fill-dark-disabled': activeState && disabled,
      'fill-tertiary-active': !activeState && !disabled,
      'fill-tertiary': !activeState && disabled,
    },
    className
  );

export const getToggleCircleClass = ({ activeState, loading }: { activeState: boolean; loading: boolean }) =>
  classNames(
    'transition-transform duration-500 ease-in-out transform rounded-full flex items-center justify-center w-4 h-4 shadow-[0px_3px_8px_0px_rgba(0,0,0,0.12),0px_3px_1px_0px_rgba(0,0,0,0.04)]',
    {
      'bg-primary': activeState && !loading,
      'bg-white': !activeState && !loading,
      'bg-neutral-30': loading,
      'translate-x-0': !activeState && !loading,
      'translate-x-2': loading,
      'translate-x-4': activeState && !loading,
    }
  );
